import { render, staticRenderFns } from "./stap-2.vue?vue&type=template&id=6d350e15&"
import script from "./stap-2.vue?vue&type=script&lang=js&"
export * from "./stap-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/data/www/nvpa.org/nvpa/nuxt/components/general/Breadcrumbs.vue').default,InschrijvingCv: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Cv.vue').default,InschrijvingOpleidingOverzicht: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/OpleidingOverzicht.vue').default,InschrijvingMaatwerkroute: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Maatwerkroute.vue').default,InschrijvingExtra: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Extra.vue').default,InschrijvingNavigation: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/navigation.vue').default})
